<template>
  <div class="main-content">
    <avue-crud ref="crud" :data="tableData" :option="option" :table-loading="showLoading" :page.sync="page"
      @on-load="onLoad">
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">设备ID :
              </span>
              <div class="width300">
                <el-input v-model="searchData.deviceId" placeholder="请输入" clearable maxlength="50"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">设备名称 :
              </span>
              <div class="width300">
                <el-input v-model="searchData.name" placeholder="请输入" clearable maxlength="50"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">所属用户/ID :
              </span>
              <div class="width300">
                <el-input v-model="searchData.userId" placeholder="请输入所属用户名称/ID" clearable maxlength="50"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">手机号码 :
              </span>
              <div class="width300">
                <el-input v-model="searchData.phone" placeholder="请输入" clearable maxlength="11"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">所属分组/ID :
              </span>
              <div class="width300">
                <el-input v-model="searchData.groupId" placeholder="请输入分组名称/ID" clearable maxlength="50"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">所属网关/ID :
              </span>
              <div class="width300">
                <el-input v-model="searchData.gatewayId" placeholder="请输入网关名称/ID" clearable maxlength="50"></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">时间 :
              </span>
              <div class="width300">
                <el-date-picker v-model="searchData.createTime" type="daterange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" :clearable="true">
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <el-button size="medium" type="primary" @click="handleSearch" style="margin-bottom: 10px"
              class="marginLeft10">搜索</el-button>
            <el-button size="medium" type="info" @click="handleReset" class="marginLeft10"
              style="margin-bottom: 10px">重置</el-button>
          </div>
        </div>
      </template>
      <template slot="image" slot-scope="{ row }">
        <el-image style="width: 80px; height: 80px" :src="row.image" :preview-src-list="[row.image]">
        </el-image>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleEdit(row)">查看</el-button>
      </template>
    </avue-crud>
    <el-dialog v-if="dialogVisible" title="" :visible.sync="dialogVisible" :center="true" width="60%"
      :before-close="handleClose" :close-on-click-modal="false">
      
      <div class="fault_box">
        <div class="fault_box_label">故障录波</div>
        <div class="fault_box_info">
          <div v-for="(item, index) in getFaultList()" :key="index" class="fault_box_text">
            {{ item.label }}：<span class="fault_box_hint">{{ item.value }}</span>
          </div>
        </div>
      </div>
      <WaveCharts :iData="getIdata()" :uData="getUdata()"></WaveCharts>
    </el-dialog>
  </div>
</template>

<script>
import {
  recordList,
  recordView,
  recordUpdateFaultRecord,
} from "@/api/fault/record";
import dayjs from "dayjs";
import { EClosing, MClosing, OClosing } from "@/enums/beCurrent/EBeCurrent";
import WaveCharts from "./waveCharts.vue";

export default {
  name: "index",
  components: {
    WaveCharts,
  },
  data() {
    return {
      EClosing: EClosing,
      MClosing: MClosing,
      OClosing: OClosing,
      searchData: {
        title: "",
        createTime: "",
        userId: this.$route.query.id || "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "断路器名称",
            prop: "name",
          },
          {
            label: "型号",
            prop: "productSpecModel",
          },
          {
            label: "所属用户",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属分组",
            prop: "groupName",
          },
          {
            label: "所属网关",
            prop: "gatewayName",
          },
          {
            label: "时间",
            prop: "createTime",
          },
        ],
      },
      dialogVisible: false,
      form: {
        handCloseStrategy: "0",
        localCloseStrategy: "0",
        currentQuantityUnit: "0",
        electricEnergyUnit: "0",
        powerUnit: "0",
        aphase: "0",
        bphase: "0",
        cphase: "0",
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [
          {
            label: "用户昵称",
            prop: "nickname",
            // type: "text",
            maxlength: 8,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "邮箱",
            prop: "email",
            maxlength: 100,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入邮箱",
                trigger: "blur",
              },
            ],
          },
          {
            label: "密码",
            prop: "password",
            maxlength: 20,
            span: 16,
            type: "password",
            // showWordLimit: true,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入密码",
                trigger: "blur",
              },
              {
                validator(_, value) {
                  if (value) {
                    if (value.length < 6) {
                      return Promise.reject(new Error("最少6位"));
                    }
                  }
                  return Promise.resolve(true);
                },
              },
            ],
          },
        ],
      },
      type: "", //设置内部参数 1工厂模式 2合闸策略 3单位开关定义 4电流互感器方向
      seconds: 0,
      timer: null,
      id: "",
      showFactoryCommand: false,
      uaData: [], //图表数据
      ubData: [],
      ucData: [],
      iaData: [], //图表数据
      ibData: [],
      icData: [],
      faultRecording: "", //故障录播序号
      faultDistinction: "", //故障相别
      faultReason: "", //故障原因
      faultTime: "", //故障时间
      dialogLoading: false, //选择序号之后加载25秒再重新掉详情
    };
  },
  created() { },
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      recordList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {};
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //图标弹窗
    async handleEdit(row) {
      this.id = row.id;
      await this.handView();
    },
    //选择故障录播序号
    submit() {
      this.showLoadingForm = true;
      console.log(111222333);
      recordUpdateFaultRecord({
        id: this.id,
        dataNumber: this.faultRecording,
      })
        .then((res) => {
          if (res.code == 200) {
            // this.dialogLoading = true;
            setTimeout(this.handView, 25000);
          }
        })
        .catch(() => {
          this.showLoadingForm = false;
        })
        .finally(() => { });
      // setTimeout(this.handView, 25000)
    },
    func(arr) {
      let data = [];
      let newData = [];
      for (let i = -80; i <= 20; i += 0.3125) {
        data.push(i);
      }
      for (let j = 0; j <= arr.length - 1; j += 1)
        newData.push([data[j], Number(arr[j])]);
      return newData;
    },
    handView() {
      recordView(this.id)
        .then((res) => {
          if (res.code === 200) {
            Object.assign(this, res.data);
            console.log("执行完了");
            this.dialogVisible = true;
          }
        })
        .finally(() => {
          // this.dialogLoading = false;
          this.showLoadingForm = false;
        });
    },
    //关闭
    handleClose() {
      this.dialogVisible = false;
      this.faultRecording = "";
    },
    getIdata() {
      return [
        { name: "Ia", data: JSON.parse(this.iaData) },
        { name: "Ib", data: JSON.parse(this.ibData) },
        { name: "Ic", data: JSON.parse(this.icData) },
      ];
    },
    getUdata() {
      return [
        { name: "Ua", data: JSON.parse(this.uaData) },
        { name: "Ub", data: JSON.parse(this.ubData) },
        { name: "Uc", data: JSON.parse(this.ucData) },
      ];
    },
    getFaultList() {
      return [
        { label: "故障相别", value: this.faultDistinction },
        { label: "故障原因", value: this.faultReason },
        { label: "故障时间", value: this.faultTime },
      ]; 
    }
  },
};
</script>

<style scoped>
.title {
  text-align: center;
}

.box_content {
  padding: 0 30px;
}

.box_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 30px;
  cursor: pointer;
}

.flex_echarts {
  display: flex;
  background: #373b47;
  padding: 0 15px;
}

.title_left {
  width: 5%;
  padding: 15px 0;
}

.left_name {
  height: 135px;
  line-height: 110px;
  color: #ffffff;
}

.echarts_left {
  width: 90%;
}

.fault_box {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.fault_box_label {
  margin-right: 10px;
  font-weight: bold;
  font-size: large;
}

.fault_box_info {
  display: flex;
  flex-direction: row;
}

.fault_box_text {
  margin-right: 20px;
  background-color: #f7e5e5;
  padding: 5px 10px;
  border-radius: 5px;
}

.fault_box_hint {
  color: #282828;
  font-weight: bold;
}
</style>
